import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { AuthContext } from '../../contexts/AuthContext';
import { LoadingOverlay } from '../../components/ui/LoadingOverlay';

const SignOut = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const performSignOut = async () => {
      // Perform any cleanup or API calls needed for sign out
      logout();
      
      // Redirect to login page after a brief delay
      setTimeout(() => {
        navigate('/login');
      }, 1500);
    };

    performSignOut();
  }, [logout, navigate]);

  return (
    <div className="min-h-screen bg-[#0A0F1C] flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center">
        <LogOut className="h-12 w-12 text-blue-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-white mb-2">Signing Out</h1>
        <p className="text-gray-400">Please wait while we sign you out...</p>
        <LoadingOverlay />
      </div>
    </div>
  );
};

export default SignOut;